<script lang="ts">
    import '../css/app.pcss';
    import { page } from '$app/stores';
    import { supportedLocales } from '$lib/i18n/initI18n.js';
    import type { SupportedLocale } from '$lib/i18n/initI18n.js';
    import Button from '$lib/daisyUiComponents/Button.svelte';

    const translations = {
        de: ['Ups!', 'Das hat nicht', 'geklappt', 'Fehler', 'Zurück zur Homepage'],
        en: ['Whoops!', "That didn't", 'work', 'Error', 'Back to the homepage']
    };

    const languageParamRegex = new RegExp('^/(' + supportedLocales.join('|') + ')');
    const languageParam = languageParamRegex.exec($page.url.pathname)?.[1] as SupportedLocale | undefined;

    const translation = translations[languageParam!] ? translations[languageParam!] : translations.en;
</script>

<svelte:head>
    <link rel="canonical" href={$page.url.toString().replace('www.', '')} />
</svelte:head>

<div class="container mx-auto px-[5%] my-24">
    <div class={`max-w-4xl mx-auto`}>
        <div class="mt-4 bg-[#414141] p-[6%] sm:p-[8%] items-center justify-center text-white flex flex-col">
            <h2 class="text-4xl sm:text-5xl text-center text-white font-bold uppercase tracking-wide mt-3">
                <span class="text-primary">{translation[0]}</span>
                {translation[1]}<br />
                {translation[2]}
                <span class="text-primary">:/</span>
            </h2>
            <p class="text-xl text-secondary max-w-[350px] text-center my-8">
                {translation[3]}: {$page.error?.message}
            </p>
            <Button color="primary" class="uppercase text-lg" href="/" data-sveltekit-reload>
                {translation[4]}
            </Button>
        </div>
    </div>
</div>
